
import React from 'react';
import EmailVerification from '@/components/account-setup/EmailVerification';
import InvalidLink from '@/components/account-setup/InvalidLink';
import AccountSetupForm from '@/components/account-setup/AccountSetupForm';
import { useAccountSetup } from '@/components/account-setup/useAccountSetup';

const AccountSetup = () => {
  const {
    email,
    setEmail,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    isLoading,
    isLinkValid,
    validationError,
    isVerifying,
    handleSubmit
  } = useAccountSetup();
  
  if (isVerifying) {
    return <EmailVerification />;
  }
  
  if (!isLinkValid) {
    return <InvalidLink />;
  }
  
  return (
    <AccountSetupForm
      email={email}
      firstName={firstName}
      lastName={lastName}
      password={password}
      confirmPassword={confirmPassword}
      isLoading={isLoading}
      validationError={validationError}
      onEmailChange={(e) => setEmail(e.target.value)}
      onFirstNameChange={(e) => setFirstName(e.target.value)}
      onLastNameChange={(e) => setLastName(e.target.value)}
      onPasswordChange={(e) => setPassword(e.target.value)}
      onConfirmPasswordChange={(e) => setConfirmPassword(e.target.value)}
      onSubmit={handleSubmit}
    />
  );
};

export default AccountSetup;
